<template>
  <div class="container-fluid" >
    <headerApp :title="this.translate('upgradeTitle')"></headerApp>
    <div class="row">
        <div class="col-xs-24">
            <div class="col-container">
                <div id='form' class='form row' v-if="!success">
                    <h1 v-lang.upgradeTitle>Registrar como chofer</h1>
                    <div class="form-input-wrapper">
                        <span class="form-label form-label--foto-perfil" v-lang.fotoPerfil>Foto de perfil</span>
                        <div class='profile_image-container'>
                            <div class="profile-pic" :class="{'profile-error': profilePicError.state}" @click="changePhoto" v-imgSrc="profilePic.src">
                                <button @click="changePhoto" class="profile_image-edit" :class="{'has-error': profilePicError.state}">
                                    <svg-item :size="24" :icon="'editar'"></svg-item>
                                </button>
                                <upload-file :name="'profile'" @change="onProfilePicChange" ref="profile"></upload-file>
                            </div>
                        </div>
                        <span class="error profile-error--text" v-if="profilePicError.state"> {{profilePicError.message}} </span>
                    </div>
                    <div class="form-input-wrapper">
                        <label class="form-label" for="txt_dni" v-lang.dni>DNI</label>
                        <input v-jump:focus="'txt_celular'" ref="txt_dni" class="form-input" maxlength="20" type="text" id="txt_dni" v-model='dni' :class="{'has-error': dniError.state }"/>
                        <span class="error" v-if="dniError.state"> {{dniError.message}} </span>
                    </div>
                    <div class="form-input-wrapper">
                        <label class="form-label" for="txt_celular" v-lang.celular>Celular</label>
                        <input type="number" v-jump:focus="'txt_patente'" class="form-input" ref="txt_celular" maxlength="25" id="txt_celular" v-model='celular' :class="{'has-error': celularError.state }"/>
                        <span class="error" v-if="celularError.state"> {{celularError.message}} </span>
                    </div>
                    <div class="form-input-wrapper" v-if="settings.modulo_chofer_acepta_pago_electronico">
                        <span for="rad-pago-electronico" class="form-label form-label--radio" v-lang.aceptaPagoElectronico>¿Acepta pago electrónico?</span>
                        <span class="form-radio-option">
                            <input id="rad-pago-electronico" type="radio" name="acepta_pago_electronico" :checked="aceptaPagoElectronico" v-model="aceptaPagoElectronico" v-bind:value="true">
                            <label for="rad-pago-electronico" v-lang.si>Si</label>
                        </span>
                        <span class="form-radio-option">
                            <input id="rad-pago-efectivo" type="radio" name="acepta_pago_electronico" :checked="!aceptaPagoElectronico" v-model="aceptaPagoElectronico" v-bind:value="false">
                            <label for="rad-pago-efectivo" v-lang.no>No</label>
                        </span>
                    </div>
                    <div class="form-input-wrapper" v-if="settings.modulo_diferenciar_genero">
                        <span class="form-label form-label--radio" v-lang.genero>Género</span>
                        <span class="form-radio-option">
                            <input id="rad-genero-mujer" type="radio" name="gender" :checked="gender === 'M'" v-model="gender" value="M">
                            <label for="rad-genero-mujer" v-lang.mujer>Mujer</label>
                        </span>
                        <span class="form-radio-option">
                            <input id="rad-genero-varon" type="radio" name="gender" :checked="gender === 'V'" v-model="gender" value="V">
                            <label for="rad-genero-varon" v-lang.varon>Varón</label>
                        </span>
                        <span class="form-radio-option">
                            <input id="rad-genero-na" type="radio" name="gender" :checked="gender === 'N'" v-model="gender" value="N">
                            <label for="rad-genero-na" v-lang.no_especifica>No especifica</label>
                        </span>
                    </div>
                    <div class="card-row card-row--company" v-if="settings.modulo_pasajero_mascotas">
                        <div class="card-center">
                            <input type="checkbox" v-model="acepta_mascotas" id="mascotas">
                            <label for="mascotas" v-lang.aceptaMascotas>
                                Acepta mascotas?
                            </label>
                        </div>
                    </div>
                    <div class="card-row card-row--company" v-if="settings.modulo_pasajero_mascotas">
                        <div class="card-center">
                            <input type="checkbox" v-model="acepta_viaje_afuera" id="acepta_viaje_afuera">
                            <label for="acepta_viaje_afuera" v-lang.aceptaViajeAfuera>
                                Acepta Viaje Afuera?
                            </label>
                        </div>
                    </div>
                    <div class="form-input-wrapper" v-if="settings.solicitar_licencia_conducir">
                        <label class="form-label" for="txt_licencia" v-lang.licenciaConductor>Licencia de conducir</label>
                        <input v-jump:focus="'txt_patente'" class="form-input" ref="txt_licencia" maxlength="15" type="text" id="txt_licencia" v-model='licenciaConducir' :class="{'has-error': licenciaError.state }"/>
                        <span class="error" v-if="licenciaError.state"> {{licenciaError.message}} </span>
                    </div>
                    <div class="form-input-wrapper" v-if="settings.solicitar_cuenta_bancaria">
                        <label class="form-label" for="txt_bank_account" v-lang.cuentaBancaria>Cuenta bancaria (CBU, CVU o ALIAS)</label>
                        <input v-jump:focus="'txt_patente'" class="form-input" ref="txt_bank_account" maxlength="30" type="text" id="txt_bank_account" v-model='cuentaBancaria' :class="{'has-error': cuentaBancariaError.state }"/>
                        <span class="error" v-if="cuentaBancariaError.state"> {{cuentaBancariaError.message}} </span>
                    </div>
                    <h3 v-lang.datosVehiculo v-lang.confirmacionDatos>Confirmación de los datos</h3>
                    <div class="form-input-wrapper">
                        <span v-lang.documentacionNecesaria>Por favor adjunta la imagen del tarjetón para poder verificar tu usuario como chofer.</span>
                        <div class='profile_image-container'>
                            <button ref="btn_register" @click="uploadFiles" id="btn_register" class="btn btn-primary" :class="{'has-error': documentationError.state }" :disabled="documentsFiles.length > 5"> <span v-lang.uploadFiles> Subir archivo </span> </button>
                            <upload-file :multiple="'true'" :name="'file'" @change="onUploadFiles" ref="file"></upload-file>
                            <div class="documentation" v-bind:key="document.src" v-for="(document, index) in documentsFiles">
                                <div :class="{'documentation-error-img': document.error}" class="documentation-pic" v-imgSrc="document.src">
                                    <span class="delete-file" @click="deleteFile(index)">
                                        <svg-item :size="18" :icon="'cerrar'"></svg-item>
                                    </span>
                                </div>
                            </div>
                            <span class="error documentation-error" v-if="documentationError.state"> {{documentationError.message}} </span>
                        </div>
                    </div>
                    <h3 v-lang.datosVehiculo>Datos del vehículo</h3>
                    <div class="form-input-wrapper" v-if="settings.modulo_delivery">
                        <span for="rad-tipo-vehiculo" class="form-label form-label--radio" v-lang.preguntaTipoVehiculo>¿Qué vehículo manejas?</span>
                        <span class="form-radio-option">
                            <input id="rad-tipo-vehiculo-moto" type="radio" name="tipo_vehiculo" :checked="esBici" v-model="esBici" v-bind:value="false">
                            <label for="rad-tipo-vehiculo-moto">Motocicleta</label>
                        </span>
                        <span class="form-radio-option">
                            <input id="rad-tipo-vehiculo-bici" type="radio" name="tipo_vehiculo" :checked="!esBici" v-model="esBici" v-bind:value="true">
                            <label for="rad-tipo-vehiculo-bici">Bicicleta</label>
                        </span>
                    </div>
                    <div class="form-input-wrapper">
                        <label class="form-label" for="txt_patente" v-lang.patente>Patente</label>
                        <input v-jump:focus="'txt_chapa'" class="form-input" ref="txt_patente" maxlength="15" type="text" id="txt_patente" v-model='patente' :class="{'has-error': patenteError.state }" :disabled="esBici" />
                        <span class="error" v-if="patenteError.state"> {{patenteError.message}} </span>
                    </div>
                    <div class="form-input-wrapper" v-if="settings.solicitar_chapa">
                        <label class="form-label" for="txt_chapa" v-lang.chapa>Chapa</label>
                        <input v-jump:focus="'txt_descripcionVehiculo'" class="form-input" ref="txt_chapa" maxlength="15" type="text" id="txt_chapa" v-model='chapa' :class="{'has-error': chapaError.state }"  :disabled="esBici"/>
                        <span class="error" v-if="chapaError.state"> {{chapaError.message}} </span>
                    </div>
                    <div class="form-input-wrapper">
                        <label class="form-label" for="txt_descripcionVehiculo" v-lang.descripcionVehiculo>Descripción del vehiculo</label>
                        <input v-jump:focus="'txt_modelo'" class="form-input" ref="txt_descripcionVehiculo" maxlength="40" type="text" id="txt_descripcionVehiculo" v-model='descripcionVehiculo' :class="{'has-error': descripcionVehiculoError.state }" :disabled="esBici" />
                        <span class="error" v-if="descripcionVehiculoError.state"> {{descripcionVehiculoError.message}} </span>
                    </div>
                    <div class="form-input-wrapper">
                        <label class="form-label" for="txt_modelo" v-lang.modelo>Modelo</label>
                        <input type="number" min="1980" :max="(new Date()).getFullYear() + 1" v-jump:focus="'txt_color'" class="form-input" ref="txt_modelo" maxlength="4" id="txt_modelo" v-model='modelo' :class="{'has-error': modeloError.state }"  :disabled="esBici"/>
                        <span class="error" v-if="modeloError.state"> {{modeloError.message}} </span>
                    </div>
                    <div class="form-input-wrapper">
                        <label class="form-label" for="txt_color" v-lang.color>Color</label>
                        <input type="text"   v-jump:focus="'txt_companiaAseguradora'" class="form-input" ref="txt_color"  id="txt_color" v-model='color' :class="{'has-error': modeloError.state }"  :disabled="esBici"/>
                        <span class="error" v-if="colorError.state"> {{colorError.message}} </span>
                    </div>
                    <div class="form-input-wrapper">
                        <label class="form-label" for="txt_companiaAseguradora" v-lang.companiaAseguradora>Compañía aseguradora</label>
                        <input v-jump:focus="'cbx_terms'" class="form-input" ref="txt_companiaAseguradora" maxlength="40" type="text" id="txt_companiaAseguradora" v-model='companiaAseguradora' :class="{'has-error': companiaAseguradoraError.state }"  :disabled="esBici"/>
                        <span class="error" v-if="companiaAseguradoraError.state"> {{companiaAseguradoraError.message}} </span>
                    </div>
                    <div class="form-input-wrapper" v-if="settings.modulo_tipo_vehiculos && settings.tiposVehiculo && settings.tiposVehiculo.length">
                        <label class="form-label" for="ddl_tipo_vehiculo" v-lang.tipoVehiculo>Tipo de vehículo</label>
                        <select v-model='tipoVehiculo' id="ddl_tipo_vehiculo" class="form-select" :class="{'has-error': tipoVehiculoError.state }">
                            <option v-for="t in settings.tiposVehiculo" v-bind:value="t.id" v-bind:key="t.id">
                                {{ t.name }}
                            </option>
                        </select>
                        <span class="error" v-if="tipoVehiculoError.state"> {{ tipoVehiculoError.message }} </span>
                    </div>
                    <div class="form-input-wrapper" v-if="settings.modulo_tipo_servicios && settings.tiposServicio && settings.tiposServicio.length">
                        <label class="form-label" for="ddl_tipo_vehiculo" v-lang.tipoServicio>Servicios que realiza</label>
                        <ul class="list-unstyled">
                            <li v-for="s in settings.tiposServicio" v-bind:key="s.id">
                                <input type="checkbox" :value="s.id" v-model="tiposServicios">
                                <span>{{ $translateFromText(s.name) }}</span>
                            </li>
                        </ul>
                        <span class="error" v-if="tipoServicioError.state"> {{ tipoServicioError.message }} </span>
                        <br />
                    </div>
                    <div class="terms">
                        <input v-jump:click.blur="'btn_register'" type="checkbox" ref="cbx_terms" id="cbx_terms" v-model='termsAndConditions' />
                        <label class="form-label" for="cbx_terms"><router-link :to="{name: 'terms'}" v-lang.termsAndConditions>He leído y acepto los términos y condiciones</router-link></label>
                        <button @click="register" ref="btn_register" id="btn_register" class="btn btn-primary" :disabled="loading || !termsAndConditions"> <span v-if="!loading" v-lang.register> Crear cuenta </span> <loader :flag="loading"> </loader>  </button>
                    </div>
                </div>
                <div class="form row" v-else>
                    <p v-lang.registerMessage>Te hemos enviado un código de verificación a tu e-mail para que puedas activar tu cuenta y comenzar a compartir viajes. </p>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import dialogs from '../../services/dialogs.js';
import bus from '../../services/bus-event';
import router from '../../router';
import Calendar from '../elements/Calendar';
import Error from '@/services/inputError';
import Forms from '../mixins/forms';

let defaultProfilePic = require('@/assets/img/default.jpg');

export default {
    name: 'upgrade',
    data () {
        return {
            dni: '',
            celular: '',
            patente: '',
            color: '',
            chapa: '',
            descripcionVehiculo: '',
            modelo: '',
            licenciaConducir: '',
            cuentaBancaria: '',
            companiaAseguradora: '',
            termsAndConditions: false,
            loading: false,
            success: false,
            aceptaPagoElectronico: false,
            dniError: new Error(),
            celularError: new Error(),
            patenteError: new Error(),
            chapaError: new Error(),
            licenciaError: new Error(),
            cuentaBancariaError: new Error(),
            descripcionVehiculoError: new Error(),
            tipoVehiculoError: new Error(),
            tipoServicioError: new Error(),
            modeloError: new Error(),
            colorError: new Error(),
            companiaAseguradoraError: new Error(),
            documentationError: new Error(),
            profilePicError: new Error(),
            profilePic: {
                data: null,
                src: defaultProfilePic
            },
            documentsFiles: [],
            esBici: false,
            tipoVehiculo: '',
            tiposServicios: [],
            acepta_mascotas: false,
            acepta_viaje_afuera: false,
            gender: 'M'
        };
    },

    computed: {
        ...mapGetters({
            checkLogin: 'auth/checkLogin',
            isMobile: 'device/isMobile',
            zonas: 'company/zonas',
            tempData: 'tempCache/upgradeChoferData',
            settings: 'company/config'
        }),
        profilePicSrc () {
            return this.profilePic.src;
        }
    },

    mounted () {
        this.language = this.$getLang();
        bus.on('back-click', this.onBackClick);
        if (this.settings.modulo_tipo_vehiculos && this.settings.tiposVehiculo && this.settings.tiposVehiculo.length > 0) {
            this.tipoVehiculo = this.settings.tiposVehiculo[0].id.toString();
        }
        if (this.tempData) {
            this.dni = this.tempData.dni;
            this.celular = this.tempData.celular;
            this.patente = this.tempData.patente;
            this.color = this.tempData.color;
            this.chapa = this.tempData.chapa;
            this.descripcionVehiculo = this.tempData.descripcionVehiculo;
            this.modelo = this.tempData.modelo;
            this.companiaAseguradora = this.tempData.companiaAseguradora;
            this.termsAndConditions = this.tempData.termsAndConditions;
            this.profilePic = this.tempData.profilePic;
            this.documentsFiles = this.tempData.documentsFiles;
            this.aceptaPagoElectronico = this.tempData.aceptaPagoElectronico;
            this.esBici = this.tempData.esBici;
            this.tipoVehiculo = this.tempData.tipoVehiculo;
            this.acepta_mascotas = this.tempData.acepta_mascotas;
            this.acepta_viaje_afuera = this.tempData.acepta_viaje_afuera;
            if (this.tempData.gender) {
                this.gender = this.tempData.gender;
            }
        }
    },

    methods: {
        ...mapActions({
            doUpgrade: 'passenger/upgradeChofer',
            doLogin: 'auth/login',
            saveViewData: 'tempCache/set',
            resetViewData: 'tempCache/reset',
            logout: 'auth/logout'
        }),
        validate (esBici) {
            let globalError = false;
            console.log('tipoVehiculo', this.tipoVehiculo);
            if (!esBici) {
                if (this.patente.length < 1) {
                    this.patenteError.state = true;
                    this.patenteError.message = this.translate('forgetPatente');
                    globalError = true;
                }
                if (this.chapa.length < 1 && this.settings.solicitar_chapa) {
                    this.chapaError.state = true;
                    this.chapaError.message = this.translate('forgetChapa');
                    globalError = true;
                }
                if (this.licenciaConducir.length < 1 && this.settings.solicitar_licencia_conducir) {
                    this.licenciaError.state = true;
                    this.licenciaError.message = this.translate('forgetLicencia');
                    globalError = true;
                }
                if (this.cuentaBancaria.length < 1 && this.settings.solicitar_cuenta_bancaria) {
                    this.cuentaBancariaError.state = true;
                    this.cuentaBancariaError.message = this.translate('forgetCuentaBancaria');
                    globalError = true;
                }
                if (this.companiaAseguradora.length < 1) {
                    this.companiaAseguradoraError.state = true;
                    this.companiaAseguradoraError.message = this.translate('forgetCompaniaAseguradora');
                    globalError = true;
                }
                if (this.modelo.length < 1) {
                    this.modeloError.state = true;
                    this.modeloError.message = this.translate('forgetModelo');
                    globalError = true;
                }
                if (this.color.length < 1) {
                    this.colorError.state = true;
                    this.colorError.message = this.translate('forgetColor');
                    globalError = true;
                }
                if (this.descripcionVehiculo.length < 1) {
                    this.descripcionVehiculoError.state = true;
                    this.descripcionVehiculoError.message = this.translate('forgetDescripcionVehiculo');
                    globalError = true;
                }

                if (this.settings.modulo_tipo_vehiculos && this.settings.tiposVehiculo && this.settings.tiposVehiculo.length > 0 && !(this.tipoVehiculo > 0)) {
                    this.tipoVehiculoError.state = true;
                    this.tipoVehiculoError.message = this.translate('forgetTipoVehiculo');
                    globalError = true;
                }
                if (this.settings.modulo_tipo_servicios && this.settings.tiposServicio && this.settings.tiposServicio.length > 0 && !(this.tiposServicios.length > 0)) {
                    this.tipoServicioError.state = true;
                    this.tipoServicioError.message = this.translate('forgetTipoServicio');
                    globalError = true;
                }
            }
            if (this.settings.modulo_diferenciar_genero && !this.gender) {
                dialogs.message('Debe seleccionar su género', { duration: 10, estado: 'error' });
                globalError = true;
            }
            if (this.dni.length < 1) {
                this.dniError.state = true;
                this.dniError.message = this.translate('forgetDni');
                globalError = true;
            }
            if (this.celular.length < 1) {
                this.celularError.state = true;
                this.celularError.message = this.translate('forgetCelular');
                globalError = true;
            }
            if (!this.profilePic.data) {
                this.profilePicError.state = true;
                this.profilePicError.message = this.translate('forgetProfilePic');
                globalError = true;
            } /* else if (this.profilePic.data.size > 4096 * 1024) {
                this.profilePicError.state = true;
                this.profilePicError.message = this.translate('bigImages');
                globalError = true;
            } */
            if (this.documentsFiles.length === 0) {
                this.documentationError.state = true;
                this.documentationError.message = this.translate('forgetDocumentacion');
                globalError = true;
            } else {
                /* let errorSizeFlag = false;
                for (let id = 0; id < this.documentsFiles.length; id++) {
                    if (this.documentsFiles[id].data.size > 4096 * 1024) {
                        errorSizeFlag = true;
                        let tempDocumentWithError = this.documentsFiles[id];
                        tempDocumentWithError.error = true;
                        this.$set(this.documentsFiles, id, tempDocumentWithError);
                    }
                }
                if (errorSizeFlag) {
                    this.documentationError.state = true;
                    this.documentationError.message = this.translate('bigImage');
                } */
                if (this.settings.min_register_cantidad_archivos > 0 && this.settings.min_register_cantidad_archivos > this.documentsFiles.length) {
                    this.documentationError.state = true;
                    this.documentationError.message = this.translate('minDocumentacion');
                    globalError = true;
                }
            }
            return globalError;
        },
        register () {
            console.log(this.settings.modulo_delivery, this.esBici);
            if (this.validate(this.settings.modulo_delivery && this.esBici)) {
                this.jumpToError();
                return;
            }
            let data = new FormData();
            let dataFields = {
                dni: this.dni,
                celular: this.celular,
                patente: this.patente,
                chapa: this.chapa,
                licencia_conducir: this.licenciaConducir,
                bank_account: this.cuentaBancaria,
                tipo_auto: this.descripcionVehiculo,
                modelo: this.modelo,
                seguro: this.companiaAseguradora,
                terms: this.termsAndConditions,
                acepta_mascotas: this.acepta_mascotas,
                acepta_viaje_afuera: this.acepta_viaje_afuera
            };
            if (this.settings.modulo_diferenciar_genero) {
                dataFields.gender = this.gender;
            }
            if (this.settings.modulo_chofer_acepta_pago_electronico) {
                dataFields.acepta_pago_electronico = this.aceptaPagoElectronico;
            }
            if (this.settings.modulo_delivery) {
                dataFields.es_bici = this.esBici;
            }
            if (this.settings.modulo_tipo_vehiculos && this.settings.tiposVehiculo && this.settings.tiposVehiculo.length > 0 && this.tipoVehiculo > 0) {
                dataFields.vehicle_type_id = this.tipoVehiculo;
            }
            console.log(this.settings.modulo_tipo_servicios, this.settings.tiposServicios);
            console.log(this.tiposServicios);
            if (this.settings.modulo_tipo_servicios && this.settings.tiposServicio && this.settings.tiposServicio.length > 0 && this.tiposServicios.length > 0) {
                for (let id = 0; id < this.tiposServicios.length; id++) {
                    data.append('servicios[]', this.tiposServicios[id]);
                }
            }
            for (let obj in dataFields) {
                data.append(obj, dataFields[obj]);
            }
            data.append('imgProfile', this.profilePic.data);
            for (let id = 0; id < this.documentsFiles.length; id++) {
                data.append('imgCarton[]', this.documentsFiles[id].data);
            }
            this.loading = true;
            this.doUpgrade(data).then((data) => {
                this.loading = false;
                this.resetViewData({key: 'view', subKey: 'upgradeChofer'});
                dialogs.message(this.translate('upgradeSuccess'), { duration: 10 });
                this.logout();
            }).catch((err) => {
                if (err && err.status === 422) {
                    this.loading = false;
                    if (typeof err.data === 'string' || err.data instanceof String) {
                        dialogs.message(err.data, { duration: 10, estado: 'error' });
                    } else {
                        for (let keyError in err.data) {
                            if (err.data.hasOwnProperty(keyError)) {
                                dialogs.message(err.data[keyError][0], { duration: 10, estado: 'error' });
                            }
                        }
                    }
                } else {
                    dialogs.message(this.translate('conectionError'), { duration: 10, estado: 'error' });
                    console.error(err);
                }
                this.loading = false;
            });
        },
        onBackClick () {
            router.back();
        },
        onProfilePicChange (data) {
            console.log('onProfilePicChange', data);
            this.profilePic.data = this.$refs.profile.$el.files[0];
            this.profilePic.src = URL.createObjectURL(this.$refs.profile.$el.files[0]);
        },
        changePhoto () {
            this.$refs.profile.show();
        },
        onUploadFiles () {
            let uploadFlag = false;
            let fileDataArray = this.$refs.file.$el.files;
            let length = this.documentsFiles.length + fileDataArray.length > 5 ? 6 - this.documentsFiles.length : fileDataArray.length;
            for (let id = 0; id < length; id++) {
                this.documentsFiles.push({
                    data: fileDataArray[id],
                    src: URL.createObjectURL(fileDataArray[id])
                });
                uploadFlag = true;
            }
            if (uploadFlag) {
                this.documentationError.state = false;
            }
            this.$refs.file.$el.value = '';
        },
        uploadFiles () {
            this.$refs.file.show();
        },
        deleteFile (index) {
            this.documentsFiles.splice(index, 1);
            this.documentationError.state = false;
        }
    },

    watch: {
        dni () { this.dniError.state = false; },
        celular () { this.celularError.state = false; },
        patente () { this.patenteError.state = false; },
        chapa () { this.chapaError.state = false; },
        descripcionVehiculo () { this.descripcionVehiculoError.state = false; },
        tipoVehiculo () { this.tipoVehiculoError.state = false; },
        tipoServicio () { this.tipoServicioError.state = false; },
        modelo () { this.modeloError.state = false; },
        color () { this.colorError.state = false; },
        companiaAseguradora () { this.companiaAseguradoraError.state = false; },
        profilePicSrc () {
            if (this.profilePic.src) {
                this.profilePicError.state = false;
            }
        }
    },

    beforeDestroy () {
        bus.off('back-click', this.onBackClick);
        let data = {};
        data.dni = this.dni;
        data.celular = this.celular;
        data.patente = this.patente;
        data.chapa = this.chapa;
        data.descripcionVehiculo = this.descripcionVehiculo;
        data.modelo = this.modelo;
        data.companiaAseguradora = this.companiaAseguradora;
        data.termsAndConditions = this.termsAndConditions;
        data.profilePic = this.profilePic;
        data.documentsFiles = this.documentsFiles;
        data.aceptaPagoElectronico = this.aceptaPagoElectronico;
        data.esBici = this.esBici;
        if (this.settings.modulo_diferenciar_genero) {
            data.gender = this.gender;
        }
        this.saveViewData({key: 'view', subKey: 'upgradeChofer', data: data});
    },
    components: {
        Calendar
    },
    mixins: [Forms]
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .container-fluid {
        background: var(--form-background-color);
        min-height: 100%;
        margin-right: auto;
        margin-left: auto;
        padding-left: 10px;
        padding-right: 10px;
    }
    .form-input-wrapper {
        margin-top: 0;
    }
    .form-input-wrapper--range {
        margin-top: 2em;
        margin-bottom: 1.4em;
    }
    .col-container {
        padding: 0 .4em;
    }
    .button-box {
        margin-top: 1.8rem;
    }
    span.error {
        display: block;
        font-size: 12px;
        margin-top: -5px;
        color: red;
        font-weight: bold;
    }
   .form {
        padding: 1.4em;
        margin: 1.2em 0;
        background-color: white;
        box-shadow: 0px 1px 5px 3px rgba(0, 0, 0, .1);
        margin: 0 -16px;
    }
    .button-box input[type="checkbox"] {
        display: inline-block;
        vertical-align: top;
    }
    .button-box label {
        display: inline-block;
        width: calc(100% - 20px);
    }
    p {
        margin-top: 0;
    }
    .cbx_terms {
        display: inline;
    }
   .form {
        padding: 1em;
    }
    .terms input[type="checkbox"] {
        display: inline-block;
        vertical-align: top;
    }
    .terms label {
        display: inline-block;
        width: calc(100% - 20px);
    }
    .terms button {
        display: block;
    }
    .profile_image-edit {
        position: absolute;
        background: transparent;
        outline: none;
        border: 0;
        bottom: 0;
        right: 0;
    }
    .profile-pic {
        max-width: 244px;
        max-height: 244px;
        position: relative;
        background-repeat: no-repeat;
        background-size: cover;
        border-radius: 100%;
        width: 50vw;
        height: 50vw;
        margin: 0 auto;
        cursor: pointer;
    }
    .loading {
        opacity: .3;
    }
    .form-label--foto-perfil {
        margin-top: 2em;
    }
    div.documentation:first-of-type {
        margin-top: 1em;
    }
    .documentation {
        width: 49%;
        display: inline-block;
    }
    .documentation-pic {
        width: 90%;
        margin-left: 5%;
        height: 100px;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: left center;
        margin-bottom: .4em;
        position: relative;
    }
    .delete-file {
        background-color: rgba(255, 255, 255, .4);
        border-radius: 100%;
        position: absolute;
        top: .4em;
        right: .4em;
        cursor: pointer;
        height: 20px;
        width: 20px;
        text-align: center;
        line-height: 20px;
    }
    .profile-error,
    .documentation-error-img {
        border: 1px solid red;
    }
    .profile-error--text {
        width: 100%;
        text-align: center;
        padding-top: 1.3em;
    }
    .documentation-error {
        padding-top: 1.3em;
    }
    @media (min-width: 450px) {
        .documentation {
            width: 33%;
            display: inline-block;
        }
    }
    input[disabled] {
        background: #EEE;
    }
</style>



// WEBPACK FOOTER //
// src/components/views/UpgradeChofer.vue